import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { blogPosts } from "@/data/blogPosts";
import Footer from "@/components/Footer";
import { usePageMeta } from "@/seo";

export default function BlogHub() {
  usePageMeta("/blog");
  return (
    <div className="min-h-screen bg-[#F7F5F0]" data-testid="blog-hub-page">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-[#E4DCCF]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="font-heading text-xl text-[#1A221E] tracking-tight">
            Dr. Greenspan
          </Link>
          <nav className="hidden sm:flex items-center gap-8">
            <Link to="/#about" className="font-body text-sm text-[#5C6A61] hover:text-[#1A221E] transition-colors">About</Link>
            <Link to="/#services" className="font-body text-sm text-[#5C6A61] hover:text-[#1A221E] transition-colors">Services</Link>
            <Link to="/blog" className="font-body text-sm text-[#C87B5D] font-medium">Blog</Link>
            <Link to="/#contact" className="font-body text-sm text-[#5C6A61] hover:text-[#1A221E] transition-colors">Contact</Link>
            <Link 
              to="/book-online" 
              className="font-body text-sm font-medium text-white bg-[#C87B5D] hover:bg-[#b56a4e] px-5 py-2 rounded-full transition-colors"
            >
              Book Online
            </Link>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="py-16 sm:py-24 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <p className="font-body text-xs tracking-[0.2em] uppercase font-bold text-[#C87B5D] mb-4">
            Wellness Articles
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-medium text-[#1A221E] tracking-tighter leading-none mb-6">
            Practical Tips for <br />Everyday Wellness
          </h1>
          <p className="font-body text-base sm:text-lg text-[#5C6A61] max-w-2xl">
            Simple, actionable guidance from forty years of chiropractic practice — helping you move better and hurt less.
          </p>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="pb-24 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group bg-white rounded-3xl border border-[#E4DCCF] p-8 hover:shadow-lg hover:border-[#C87B5D]/30 transition-all duration-300"
                data-testid={`blog-card-${post.slug}`}
              >
                <h2 className="font-heading text-xl sm:text-2xl font-medium text-[#1A221E] tracking-tight mb-4 group-hover:text-[#3A4F41] transition-colors leading-tight">
                  {post.title}
                </h2>
                <p className="font-body text-sm text-[#5C6A61] leading-relaxed mb-6 line-clamp-3">
                  {post.excerpt}
                </p>
                <span className="inline-flex items-center gap-2 font-body text-sm font-medium text-[#C87B5D] group-hover:gap-3 transition-all">
                  Read More
                  <ArrowRight size={16} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
